import { useState, useEffect } from 'react';
import { msUntilNextBoundary } from '../logic/openList';

/**
 * Re-render at the next list-cycle start / midnight (then re-arm), so a board left open
 * on an iPad flips to the new cycle on its own. Returns a counter to use as a dep.
 */
export function useCycleTick() {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setTimeout(() => setTick(n => n + 1), msUntilNextBoundary() + 500);
    return () => clearTimeout(id);
  }, [tick]);
  return tick;
}
